import HomePage from '@/pages/HomePage';
import ClubsPage from '@/pages/ClubsPage';
import EventsPage from '@/pages/EventsPage';
import BookingPage from '@/pages/BookingPage';
import TableBookingPage from '@/pages/TableBookingPage';
import UserPage from '@/pages/UserPage';
import ClubPage from '@/pages/ClubPage';
import ClubGalleryPage from '@/pages/ClubGalleryPage';
import SignupPage from '@/pages/SignupPage';
import LoginPage from '@/pages/LoginPage';
import ConfirmationCodePage from '@/pages/ConfirmationCodePage';
import EventSchedulePage from '@/pages/EventSchedulePage';
import EventScheduleCategoryPage from '@/pages/EventScheduleCategoryPage';
import TicketBookingPage from '@/pages/TicketBookingPage';
import TableBookingTicketPage from '@/pages/TableBookingTicketPage';
import ProfilePage from '@/pages/ProfilePage';
import ArtistPage from '@/pages/ArtistPage';
import AllCartsPage from '@/pages/AllCartsPage';
import CartPage from '@/pages/CartPage';
import PaymentPage from '@/pages/PaymentPage';
import GuestCheckoutConfirmationPage from '@/pages/GuestCheckoutConfirmationPage';
import { TransferBookingPage } from '@/pages';
import EventBookingCategoryDetailsPage from '@/pages/EventBookingCategoryDetailsPage';

export const routes = [
  { path: '/', element: <HomePage /> },
  { path: '/venues', element: <ClubsPage /> },
  { path: '/venues/:handle', element: <ClubPage /> },
  { path: '/venues/:handle/gallery', element: <ClubGalleryPage /> },
  { path: '/venues/:handle/events/:eventId', element: <EventSchedulePage /> },
  { path: '/venues/:handle/events/:eventId/booking/:eventScheduleId', element: <EventScheduleCategoryPage /> },
  { path: '/booking/tickets/:eventBookingCategoryId', element: <TicketBookingPage /> },
  { path: '/booking/reservations/:eventBookingCategoryId', element: <TableBookingTicketPage /> },
  { path: '/events', element: <EventsPage /> },
  { path: '/venues/:handle/artist/:artistId', element: <ArtistPage /> },
  { path: '/booking', element: <BookingPage /> },
  { path: '/booking/reservations/:eventId', element: <TableBookingPage /> },
  { path: '/user', element: <UserPage /> },
  { path: '/profile', element: <ProfilePage /> },
  { path: '/carts', element: <AllCartsPage /> },
  { path: '/carts/:cartId', element: <CartPage /> },
  { path: '/carts/:cartId/payment', element: <PaymentPage /> },
  { path: '/carts/:cartId/guest-checkout/confirm', element: <GuestCheckoutConfirmationPage /> },
  { path: '/signup', element: <SignupPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/confirmation-code', element: <ConfirmationCodePage /> },
  { path: '/transfer-booking/:bookingId', element: <TransferBookingPage /> },
  { path: '/transfer-booking/t/:transferId', element: <TransferBookingPage /> },
  { path: '/booking/category/:eventBookingCategoryId/details', element: <EventBookingCategoryDetailsPage /> }
];
